import { NavLink, Outlet } from "react-router";

const TABS = [
  { to: "/", label: "Hoy", icon: "☀️", end: true },
  { to: "/semana", label: "Semana", icon: "📅", end: false },
  { to: "/asistente", label: "Asistente", icon: "💬", end: false },
  { to: "/metas", label: "Metas", icon: "🎯", end: false },
  { to: "/ajustes", label: "Ajustes", icon: "⚙️", end: false },
];

export function AppShell() {
  return (
    <div className="shell">
      <main className="content">
        <Outlet />
      </main>
      <nav className="tabbar">
        {TABS.map((tab) => (
          <NavLink key={tab.to} to={tab.to} end={tab.end} className="tab">
            <span aria-hidden>{tab.icon}</span>
            {tab.label}
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
